import React from 'react';
import { makeStyles } from 'e100-react-components';

import { Typography } from 'shared/components';

const useStyles = () =>
  makeStyles(({ palette, spacing }) => ({
    container: {
      display: 'flex',
      flexDirection: 'row',
      gap: spacing(1),
      alignItems: 'center',
    },
    steeperBadge: {
      minWidth: 40,
      color: '#fff',
      backgroundColor: palette.primary.main,
      borderRadius: 16,
      padding: spacing(0.5, 1),
      lineHeight: '20px',
    },
  }))();

export const Title = ({ step, title }: { step: number; title: string }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.steeperBadge}>
        <Typography variant="caption">{step} / 2</Typography>
      </div>
      <Typography variant="h6">
        <b>{title}</b>
      </Typography>
    </div>
  );
};
